/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'

class PurchaseFirstTime extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      printInfo: [],
      pageNumber: 1,
      buttonClicked: false,
      list: [],
      fromDate: '',
      toDate: '',
      fromPrintDate: '',
      toPrintDate: '',
      customerCode: '',
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد مشتری',
          value: 'userCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام و نام خانوادگی',
          value: 'name',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام کاربری',
          value: 'username',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'تاریخ ثبت نام',
          value: 'lastPurchaseDate',
          sorted: false,
          direction: null,
          sortable: true
        }
      ]
    }
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_FIRSTTIME}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object.result,
            countAll: response.data.object.countAll,
            buttonClicked: true,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            list: [],
            countAll: 0,
            loading: false
          })
          // message.error(response.data.description)
        }
      })
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  onResultFetched(data) {
    this.setState({
      list: data
    })
  }

  changeDropDown(data) {
    this.setState({
      list: data,
      lengthProducts: this.state.countAll
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    let customerCode = this.state.customerCode

    let invoiceDateMin = this.state.fromDate
    let invoiceDateMax = this.state.toDate
    let customerUsername = document.getElementById('customerUsername').value
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (customerCode !== '') {
      filter.customerCode = customerCode.trim()
    }
    if (customerUsername !== '' && customerUsername.length) {
      filter.customerUsername = customerUsername.trim()
    }

    if (invoiceDateMin !== '') {
      filter.invoiceDateMin = invoiceDateMin
    }

    if (invoiceDateMax !== '') {
      filter.invoiceDateMax = invoiceDateMax
    }

    return filter
  }

  //

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_FIRSTTIME}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            list: response.data.object.result,
            countAll: response.data.object.countAll,
            loading: false
          })

          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
          // message.error(response.data.description)
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    let filter = this.createFilter

    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_PURCHASE_FIRSTTIME}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['registerDate'] = jMoment(excelReport[i]['registerDate']).format('jYY/jM/jD HH:mm')
            if (excelReport[i]['planDate'] !== null) {
              excelReport[i]['planDate'] =
                jMoment(excelReport[i]['planDate']).format('jYY/jM/jD') +
                ' - ' +
                excelReport[i]['planTimeFrom'].substr(0, 5) +
                ' - ' +
                excelReport[i]['planTimeTo'].substr(0, 5)
            } else {
              excelReport[i]['planDate'] = ''
            }
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')
    let columns = ['ردیف', 'کد مشتری', 'نام و نام خانوادگی', 'نام کاربری', 'تاریخ ثبت نام']

    let excelColumns = [
      {title: 'کد محصول', value: 'articleId'},
      {title: 'بارکد محصول', value: 'productCode'},
      {title: 'نام محصول', value: 'productName'},
      {title: 'نام انبار', value: 'warehouseName'},
      {title: 'نام تامین کننده', value: 'providerName'}
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش مشتریان خرید اولی"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={'تاریخ خرید از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((rfml, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{rfml.customer.userCode}</td>
                  <td>{rfml.customer.name}</td>
                  <td>{rfml.customer.username === null ? '-' : rfml.customer.username.replace(/\+98/g, '0')}</td>
                  <td>{jMoment(rfml.registerDate).format('jYY/jM/jD HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش مشتریان خرید اولی : ' + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'name'}
                field={'customer.name'}
                title={'نام و نام خانوادگی'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'customer.name'}
                field={'customer.username'}
                title={'نام کاربری'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'registerDate'}
                field={'registerDate'}
                title={'تاریخ ثبت نام'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>خرید و فروش</li>
            <li>مشتریان خرید اولی</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'/report/purchase/firstTime'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ صدور فاکتور از"
                  toLabel="تاریخ صدور فاکتور تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'فرم جست و جوی مشتری'}
                />

                <div className="formComponent">
                  <label>نام کاربری مشتری:</label>
                  <input type="text" className="form-control" id="customerUsername" name="customerUsername" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  {this.state.list.map((rfml, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * pageSize + index + 1}</td>

                      <td>
                        <Link
                          to={{
                            pathname: '/baskets',
                            search: `?userCode=${rfml.customer.userCode}`
                          }}
                          target={'_blank'}
                        >
                          {rfml.customer.userCode}
                        </Link>
                      </td>

                      <td>{rfml.customer.name}</td>
                      <td>{rfml.customer.username === null ? '-' : rfml.customer.username.replace(/\+98/g, '0')}</td>
                      <td>{jMoment(rfml.registerDate).format('jYY/jM/jD HH:mm')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PurchaseFirstTime
